<!-- AddOnsSection.vue - Section for additional products/services -->
<template>
  <div class="addons-section">
    <h3 class="section-title">Add-Ons</h3>
    
    <div class="addons-list">
      <!-- TODO: Additional products/services -->
      <p class="placeholder">Add-ons and extras will go here</p>
      
      <div class="migration-notes">
        <h4>Potential add-ons:</h4>
        <ul>
          <li>Rush production</li>
          <li>Additional imprint locations</li>
          <li>Packaging options</li>
          <li>Proof services</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddOnsSection',
  
  data() {
    return {
      selectedAddons: []
    }
  },
  
  methods: {
    toggleAddon(addonId) {
      const index = this.selectedAddons.indexOf(addonId)
      if (index > -1) {
        this.selectedAddons.splice(index, 1)
      } else {
        this.selectedAddons.push(addonId)
      }
      this.$emit('addons-changed', this.selectedAddons)
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/utils' as *;

.addons-section {
  padding: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: $color-text;
}

.addons-list {
  // Styles will be added when implementing
}

.placeholder {
  padding: 40px;
  text-align: center;
  background: $color-bg-light;
  border: 2px dashed $color-border-dark;
  color: $color-text-light;
  margin-bottom: 16px;
}

.migration-notes {
  padding: 16px;
  background: #e3f2fd;
  border-left: 4px solid #2196f3;
  
  h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    color: #1565c0;
  }
  
  ul {
    margin: 0;
    padding-left: 20px;
    font-size: 13px;
    color: $color-text-light;
    
    li {
      margin: 4px 0;
    }
  }
}
</style>
